"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceApp = exports.WorkspaceContainer = exports.WorkspaceProvider = exports.useWorkspaceAssetsDispatch = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const ui_common_uploader_1 = require("@desygner/ui-common-uploader");
const Workspace_1 = require("./Workspace");
const useWorkspaceStore_1 = require("./store/useWorkspaceStore");
var Workspace_context_1 = require("./store/Workspace.context");
Object.defineProperty(exports, "useWorkspaceAssetsDispatch", { enumerable: true, get: function () { return Workspace_context_1.useWorkspaceAssetsDispatch; } });
Object.defineProperty(exports, "WorkspaceProvider", { enumerable: true, get: function () { return Workspace_context_1.WorkspaceProvider; } });
exports.WorkspaceContainer = (0, react_1.memo)(function WorkspaceContainer({ type, credentials, collection, workspace, permissions, cardButtons, bucketName, companionUrl, objectKey, onAssetClick, onAssetDragging, options, filter, }) {
    var _a, _b;
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const translatedType = t('tool.library.' + type);
    const theme = (0, ui_common_components_1.useTheme)();
    const { title, status, search, folders, assets, actions, navigation } = (0, useWorkspaceStore_1.useWorkspaceStore)({
        type,
        collection,
        workspace,
        credentials,
        options: {
            filterYoutube: options === null || options === void 0 ? void 0 : options.filterYoutube,
        },
        filter,
    });
    const labels = (0, react_1.useMemo)(() => ({
        title: title ||
            t('tool.library.assets.title_workspace', { type: translatedType }),
        searchPlaceholder: t('tool.library.assets.search_placeholder', {
            type: translatedType.toLocaleLowerCase(),
        }),
        translatedType,
        createFolder: '',
        uploadAsset: '',
    }), [title, t, translatedType]);
    const uploader = (0, react_1.useMemo)(() => {
        const options = {
            companionUrl: companionUrl,
            objectKey: `${objectKey}/${type}/original/`,
            bucket: bucketName,
            theme: theme,
        };
        return new ui_common_uploader_1.Uploader(type, options);
    }, [companionUrl, objectKey, type, bucketName, theme]);
    const onUploadAssetClick = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        if (!uploader)
            return;
        const onComplete = (result) => {
            actions.uploadToFolder(result, type);
        };
        const onImportYoutubeVideo = (url) => {
            actions.uploadYoutubeVideoToFolder(url);
            return;
        };
        uploader.openDashboard(onComplete, onImportYoutubeVideo);
    }, [uploader, actions, type]);
    const onCreateFolder = (0, react_1.useCallback)((folderName, groups) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield actions.createFolder(folderName, type, groups);
    }), [actions, type]);
    const hasSingleFolderInFilter = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d;
        return filter &&
            !((_a = filter === null || filter === void 0 ? void 0 : filter.assets) === null || _a === void 0 ? void 0 : _a.length) &&
            ((_b = filter === null || filter === void 0 ? void 0 : filter.folders) === null || _b === void 0 ? void 0 : _b.length) === 1 &&
            ((_d = (_c = filter === null || filter === void 0 ? void 0 : filter.folders) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.resourceId) !== 'all';
    }, [filter]);
    const isSubFolder = (0, react_1.useMemo)(() => navigation.length > (hasSingleFolderInFilter ? 1 : 0), [navigation, hasSingleFolderInFilter]);
    // TODO: revisit this logic, it fetches the folder twice in the beginning
    (0, react_1.useEffect)(function navigateToSingleFolderInFilter() {
        var _a, _b;
        const folderId = (_b = (_a = filter === null || filter === void 0 ? void 0 : filter.folders) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.resourceId;
        hasSingleFolderInFilter &&
            folderId &&
            status === 'idle' &&
            navigation.length < 1 &&
            actions.navigateToFolder(folderId);
    }, [hasSingleFolderInFilter, filter, navigation, actions, status]);
    return ((0, jsx_runtime_1.jsx)(Workspace_1.Workspace, { assets: assets, cardButtons: cardButtons, collection: collection, folders: folders, isSubFolder: isSubFolder, permissions: permissions, labels: labels, search: search, status: status, type: type, onAssetClick: onAssetClick, onAssetDragging: onAssetDragging, onCreateFolder: onCreateFolder, onFolderClick: actions.navigateToFolder, onHeadingClick: actions.navigateToParent, onSearchChange: actions.search, onUploadAssetClick: onUploadAssetClick, options: {
            isQa: (_a = options === null || options === void 0 ? void 0 : options.isQa) !== null && _a !== void 0 ? _a : true,
            filterYoutube: (_b = options === null || options === void 0 ? void 0 : options.filterYoutube) !== null && _b !== void 0 ? _b : false,
        }, onLoadMoreAssets: actions.fetchResourceFromCurrentFolder }));
});
exports.WorkspaceApp = (0, react_1.memo)(function WorkspaceApp({ type, workspace, collection, permissions, cardButtons, credentials, bucketName, objectKey, companionUrl, onAssetClick, onAssetDragging, options, filter, }) {
    return ((0, jsx_runtime_1.jsx)(exports.WorkspaceContainer, { bucketName: bucketName, objectKey: objectKey, type: type, filter: filter, workspace: workspace, permissions: permissions, collection: collection, cardButtons: cardButtons, companionUrl: companionUrl, credentials: credentials, onAssetClick: onAssetClick, onAssetDragging: onAssetDragging, options: options }));
});
//# sourceMappingURL=WorkspaceContainer.js.map